import React, { useState } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpPlatformInvoiceItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceItem';
import TpPlatformInvoiceService from '../../../Services/TpPlatformInvoiceService';
import TpPlatformInvoiceSearchParams from './TpPlatformInvoiceSearchParams';
import TpPlatformInvoiceBravoJobsPopup from './TpPlatformInvoiceBravoJobsPopup';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TpPlatformInvoiceStatusesEnum from '../../../Enums/TpPlatformInvoiceStatusesEnum';
import TpPlatformInvoiceBillingPeriodOverrideItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceBillingPeriodOverrideItem';
import SetBillingPeriodWindowDescription from './SetBillingPeriodWindowDescription';

// Read-only admin page for the mirrored Prism/PrismIntl platform invoices
// (TpPlatformInvoice, imported daily by DataImporterPlatformInvoice). Clicking an
// invoice ID opens the detail popup: General fields + the embedded Invoice Items grid.
// No create/edit/delete — manual corrections stay ad-hoc-script-only (CD-5300 spec).
// The row menu's "View Bravo Jobs" action opens the billed-TpJob drill-down popup
// (CD-5294), scoped to the whole invoice. "Set Billing Period" opens a wizard to
// set/clear the manual BillingPeriodOverride (CD-5294).
const TpPlatformInvoiceAdmin = () => {
  const [searchItem, setSearchItem] = useState<any>(() => new (TpPlatformInvoiceSearchParams as any)());
  const [bravoJobsInvoice, setBravoJobsInvoice] = useState<any>(null);
  const [billingPeriodItem, setBillingPeriodItem] = useState<any>(null);

  const startSearch = (newSearchItem: any) => setSearchItem({ ...newSearchItem });

  TpPlatformInvoiceItem.viewBravoJobsFunction = (item) => setBravoJobsInvoice(item);

  // Summarized invoices warn first: their frozen summary rows keep the OLD period until the
  // invoice is manually re-processed (clear SummarizedOnUtc + delete its rows — unchanged).
  TpPlatformInvoiceItem.setBillingPeriodFunction = (item) => {
    const openEditor = () => setBillingPeriodItem(new (TpPlatformInvoiceBillingPeriodOverrideItem as any)(item));
    if (item.Status === TpPlatformInvoiceStatusesEnum.Summarized) {
      ErrorMessage.SetApprove(
        'This invoice is already summarized: its frozen summary rows keep the old billing period ' +
          'until the invoice is manually re-processed. Set the override anyway?',
        openEditor
      );
      return;
    }
    openEditor();
  };

  return (
    <div className='contentwrapper'>
      <TabOfDataTable
        type={TpPlatformInvoiceItem}
        serviceFunction={TpPlatformInvoiceService.GetAllItemsBySearching}
        convertDBItemsFunction={TpPlatformInvoiceService.ConvertDBItems}
        searchItem={searchItem}
        searchParamsType={TpPlatformInvoiceSearchParams}
        showSearchStrip={true}
        clickOnStartSearch={startSearch}
        popupEnabled={true}
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in invoice ID, number, name...'
        errorCode='TPPIA01'
        enableUrlPush={true}
        forceClearCacheOnSearch={true}
      />
      {bravoJobsInvoice && (
        <TpPlatformInvoiceBravoJobsPopup
          title={`Bravo Jobs - ${bravoJobsInvoice.InvoiceName} (${bravoJobsInvoice.ThirdPartyInvoiceId})`}
          thirdPartySource={bravoJobsInvoice.ThirdPartySource}
          thirdPartyInvoiceId={bravoJobsInvoice.ThirdPartyInvoiceId}
          clickOnCancel={() => setBravoJobsInvoice(null)}
        />
      )}
      {billingPeriodItem && (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={billingPeriodItem}
          clickOnCancel={() => setBillingPeriodItem(null)}
          clickOnSave={() => {
            setBillingPeriodItem(null);
            setSearchItem((prev: any) => ({ ...prev }));
          }}
          windowDescription={SetBillingPeriodWindowDescription}
          errorCode='TPPBP01'
        />
      )}
    </div>
  );
};

export default TpPlatformInvoiceAdmin;
